import React from "react";
import { ModalContext } from "../../../../components/BrowserAlert/modalContext";
import {
  Container,
  Button,
  Typography,
  Grid,
  InputLabel,
  TextField,
  TextareaAutosize,
  FormControl,
  Select,
  MenuItem,
  Stack,
} from "@common-ui/ui";
import { Section } from "../components";
import { AddCircle } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { procedureSlice } from "./../../../../reducers/procedureReducer";
import { Divider } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import { createProcedure } from "../../../../services";
export const CreatePanel = () => {
  let { handleModal } = React.useContext(ModalContext);
  // const [sections, setSections] = React.useState([]);
  const [expanded, setExpanded] = React.useState(false);

  const handleChangeAccordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const dispatch = useDispatch();
  const params = useParams();

  const procedure = useSelector((state) => state.procedure);
  const sections = procedure.items;
  const handleRemoveSection = (sectionId) => {
    dispatch(procedureSlice.actions.removeSection({ sectionId }));
  };
  let router = useHistory();
  React.useEffect(() => {
    dispatch(procedureSlice.actions.clearProcedure());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // let params = useParams();
  // console.log(params);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createProcedure(
        procedure,
        params.orgId,
        params.serviceTypeId,
        params.serviceOptionId
      );
      // dispatch(procedureSlice.actions.clearWorkInstruction());
      // alert("Success!");
      handleModal("Success!", "Alert")
      router.push(`/procedures`);
    } catch (error) {
      if (error?.message === "Request failed with status code 405") {
        return handleModal("Draft version already exists.", "Alert")
      }
      alert(error?.message);
    }
  };
  return (
    <Container maxWidth="xl" component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item md={2} xs={12}>
          <Typography fontWeight="700">Procedure Details:</Typography>
        </Grid>
        <Grid item md={10} xs={12}>
          <Grid container spacing={2}>
            {/*  */}
            <Grid item xs={12}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Title</Typography>
                <span>
                  <svg
                    width="16px"
                    height="16px"
                    viewBox="0 0 16 16"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fillRule="evenodd">
                      <polygon
                        id="Shape"
                        fill="#EE2E24"
                        fillRule="nonzero"
                        points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                      ></polygon>
                    </g>
                  </svg>
                </span>
              </InputLabel>
              <TextField
                sx={{ mt: "3px" }}
                size="small"
                fullWidth
                placeholder="Type"
                autoComplete="off"
                margin="normal"
                name="title"
                variant="outlined"
                value={procedure.title}
                onChange={(e) =>
                  dispatch(
                    procedureSlice.actions.handleProcedure({
                      name: e.target.name,
                      value: e.target.value,
                    })
                  )
                }
              />
            </Grid>
            {/*  */}
            <Grid item md={4} xs={12}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Description</Typography>
              </InputLabel>
              <TextField
                sx={{ mt: "3px" }}
                size="small"
                fullWidth
                placeholder="Type"
                autoComplete="off"
                margin="normal"
                name="description"
                variant="outlined"
                value={procedure.desciption}
                onChange={(e) =>
                  dispatch(
                    procedureSlice.actions.handleProcedure({
                      name: e.target.name,
                      value: e.target.value,
                    })
                  )
                }
              />
            </Grid>
            {/*  */}
            <Grid item md={4} xs={12}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Revision</Typography>
              </InputLabel>
              <TextField
                sx={{ mt: "3px" }}
                size="small"
                fullWidth
                placeholder="Type"
                autoComplete="off"
                margin="normal"
                name="revision"
                variant="outlined"
                value={procedure.revision}
                onChange={(e) =>
                  dispatch(
                    procedureSlice.actions.handleProcedure({
                      name: e.target.name,
                      value: e.target.value,
                    })
                  )
                }
              />
            </Grid>
            {/*  */}
            <Grid item md={4} xs={12}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">Status</Typography>
              </InputLabel>
              <FormControl fullWidth name="na">
                <Select
                  sx={{ mt: "3px" }}
                  onChange={(e) =>
                    dispatch(
                      procedureSlice.actions.handleProcedure({
                        name: "status",
                        value: e.target.value,
                      })
                    )
                  }
                  size="small"
                  placeholder="Select"
                  name="status"
                  variant="outlined"
                  value={procedure.status}
                  // displayEmpty
                  // renderValue={() => "Select"}
                >
                  <MenuItem value="none" disabled>
                    <em>Select</em>
                  </MenuItem>
                  {/* <MenuItem value={"IN_PROGRESS"}>In Progress</MenuItem> */}
                  <MenuItem value={"DRAFT"}>Draft</MenuItem>
                  <MenuItem value={"COMPLETED"}>Published</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontWeight="700">General notes</Typography>
              </InputLabel>
              <TextField
                sx={{ mt: "3px" }}
                size="small"
                fullWidth
                placeholder="Type"
                margin="normal"
                InputProps={{
                  inputComponent: TextareaAutosize,
                  inputProps: { minRows: 4 },
                }}
                name="notes"
                variant="outlined"
                onChange={(e) =>
                  dispatch(
                    procedureSlice.actions.handleProcedure({
                      name: "notes",
                      value: e.target.value,
                    })
                  )
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider sx={{ my: 1 }} />
      <Grid container spacing={2}>
        <Grid item md={2} xs={12}>
          <Typography fontWeight="700">Procedures Sections:</Typography>
        </Grid>
        <Grid item md={10} xs={12}>
          {Array.from(sections).map((section, index) => {
            return (
              <Section
                key={section.id}
                sectionId={section.id}
                handleRemoveSection={handleRemoveSection}
                step={index + 1}
                expanded={expanded}
                handleChangeAccordion={handleChangeAccordion}
              />
            );
          })}
          <Button
            sx={{ mt: 2 }}
            onClick={() => dispatch(procedureSlice.actions.addSection())}
            startIcon={<AddCircle />}
            // variant="outlined"
          >
            Add Section
          </Button>
          <Stack>
            <Divider sx={{ mb: 1, mt: 2 }} />

            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent="flex-end"
              spacing={{ xs: 1, md: 2 }}
              sx={{ py: 2 }}
            >
              <div>
                <Button
                  color="primary"
                  // disabled={formik.isSubmitting}
                  fullWidth
                  size="large"
                  onClick={() => router.goBack()}
                  // type="submit"
                  variant="text"
                >
                  Cancel
                </Button>
              </div>
              <div>
                <Button
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Save
                </Button>
              </div>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};
